import { Alert, AlertDescription, AlertIcon, type AlertProps, Link, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { urls } from "../../../urls";
import type { UnassessedWinner } from "./AwardSelectionContext";

export const UnassessedWinnersAlert = ({
  eventId,
  winners,
  ...alertProps
}: { eventId: string; winners: UnassessedWinner[] } & AlertProps) => {
  const { t } = useTranslation();
  if (winners.length === 0) return null;
  return (
    <Alert status="warning" rounded="md" fontSize="sm" alignItems="flex-start" {...alertProps}>
      <AlertIcon />
      <AlertDescription>
        <Stack spacing="1">
          <Text>
            {t("Winners with declared exclusion grounds", { count: winners.length })}
          </Text>
          {winners.map((winner) => (
            <Link
              key={winner.bidId}
              as={RouterLink}
              to={urls.app.sourcingEvents.bidDetail.go(eventId, winner.bidId)}
              color="smPrimary"
            >
              {t("Assess {{entry}}", { entry: winner.name })}
            </Link>
          ))}
        </Stack>
      </AlertDescription>
    </Alert>
  );
};
